// The sessions a chat's investigation has drawn a conclusion about, for its
// canvas to lay on as the chat finds them: a session counts once a claim the
// chat made rests on it, or on one of its events. A session the chat only
// read rows of (an endpoint's timeline, a broad search) is not one: a wide
// search would otherwise fill the board with sessions that bear on nothing.
// They come in the order the chat first claimed something of them.

const EVENT_KINDS = new Set(["process", "message", "prompt"]);

export function chatSessionsToLay(graph) {
  if (!graph?.nodes?.size) return [];
  const sessionOf = new Map();
  for (const e of graph.edges?.values?.() || []) {
    if (e.kind !== "in_session") continue;
    const from = graph.nodes.get(e.from);
    if (from && EVENT_KINDS.has(from.kind)) sessionOf.set(e.from, e.to);
  }
  // When each session was first claimed of: the first claim resting on it,
  // or on one of its events.
  const reached = new Map();
  const note = (key, seq) => {
    const n = graph.nodes.get(key);
    if (n?.kind !== "session") return;
    const s = Number.isFinite(seq) ? seq : Infinity;
    if (!reached.has(key) || s < reached.get(key)) reached.set(key, s);
  };
  for (const c of graph.claims || []) {
    for (const k of c.evidence || []) {
      note(k, c.seq);
      if (sessionOf.has(k)) note(sessionOf.get(k), c.seq);
    }
  }
  return [...reached.entries()]
    .map(([key, seq]) => ({ key, id: String(graph.nodes.get(key)?.id || "").toLowerCase(), seq }))
    .filter((s) => s.id)
    .sort((a, b) => a.seq - b.seq || a.id.localeCompare(b.id));
}
